<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">
        <v-flex sm3 md4 lg2>
          <v-checkbox
              label="Draft"
              :value="filters.Draft"
              row
              v-model="filters.Draft"
              @change="filter($event)"
              class="request_checkbox"
              :color="'black'"
          ></v-checkbox>
        </v-flex>
        <v-flex sm3 md4 lg2>
          <v-checkbox
              label="Published"
              :value="filters.Published"
              v-model="filters.Published"
              @change="filterPublished($event)"
              class="request_checkbox"
              :color="'black'"
          ></v-checkbox>
        </v-flex>

        <v-flex sm12 md6 lg4 style=" margin-top: 12px;">
          <v-autocomplete
              v-model="filters.title"
              :items="title_list"
              placeholder="Search By Title"
              :search-input.sync="search_title"
              item-value="title"
              item-text="title"
              clearable solo flat
              @change="searchByTitle()"
          ></v-autocomplete>
        </v-flex>

        <v-flex sm12 md6 lg4 style="display: flex; justify-content: center;">
          <v-btn
              slot="activator"
              color="rgb(248 71 6)"
              class="white--text add_notification"
          >
            <router-link to="/notifications/create" class="white--text">
              <v-icon color="#bbbbc6" class="white--text mr-2">edit
              </v-icon
              >
              Create Notification
            </router-link
            >
          </v-btn>
        </v-flex>

      </v-layout>

      <v-data-table
          no-results-text="Loading... Please wait"
          :headers="headers"
          :items="notification_list"
          :pagination.sync="pagination"
          :loading="loaders.notification_list_loader"
          :total-items="total_items"
          :rows-per-page-items="[10, 20, 50, 100]"
      >
        <template v-slot:headers="props">
          <tr>
            <th
                style="width: 27%"
                v-for="header in props.headers"
                :key="header.text"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td v-if="props.item.title">
            <router-link
                :to="{ name: 'notification', params: { id: props.item.id } }"
            >
              {{ props.item.title }}
            </router-link>
          </td>
          <td v-else>{{ " - " }}</td>

          <td v-if="props.item.body">
            <span v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md">
              {{ props.item.body.substring(0,40)+"..."}}</span>
            <span v-else>{{ props.item.body }}</span>
          </td>
          <td v-else>{{ " - " }}</td>

          <td>{{ props.item.city_name }}</td>
          <td>{{ props.item.status }}</td>
          <td>{{ props.item.updated_at | appDateTimeFormat }}</td>
        </template>
        <template slot="no-data">
          <v-layout
              row
              wrap
              justify-center
              class="text-xs-center"
              v-if="loaders.notification_list_loader"
          >
            Loading... Please wait
          </v-layout>
          <v-layout row wrap justify-center class="text-xs-center" v-else>
            No data available
          </v-layout>
        </template>
      </v-data-table>
    </v-container>
    <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
      {{ snackbar.message }}
      <v-btn
          text
          dark
          @click="snackbar.display = false"
      >
        <v-icon
            right
            color="white"
        >
          close
        </v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Index",
  data: () => {
    return {
      headers: [
        {
          text: "Title",
          value: "title",
          align: "left",
          sortable: false,
        },
        {
          text: "Body",
          value: "body",
          sortable: false,
        },
        {
          text: "City Name",
          value: "city_name",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          sortable: false,
        },
      ],
      loaders: {
        notification_list_loader: false,
      },
      notification_list: [],
      total_items: 0,
      titles: [],
      title_type: [],
      title_list: [],
      title_searched: "",
      search_title: "",
      pagination: {sortBy: "created_at", descending: false, rowsPerPage: 10},
      filters: {
        title: "",
        Published: false,
        Draft: false,
      },
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      cityList: [],
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
    search_title: {
      handler(newVal) {
        if (newVal != null && newVal.length > 3) {
          this.getTitlesList(newVal);
        }
      },
    },
    "filters.title": {
      handler(value) {
        if (value == undefined) {
          this.filters.title = "";
          this.getList();
        }
      },
    },
  },
  methods: {
    filter(e) {
      this.filters.Published = false;
      this.filters.Draft = e;

      this.getList();
    },
    filterPublished(e) {
      this.filters.Draft = false;
      this.filters.Published = e;
      this.getList();
    },
    searchByTitle() {
      this.getList();
    },
    getList: function () {
      this.loaders.notification_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/notification-list`, {
            headers: this.$headers,
            params: this.pagination,
          })
          .then((response) => {
            if (response.data.status == 1) {
              // console.log(response.data.notifications.total);
              this.notification_list = response.data.notifications.data;

              if (this.cityList && this.cityList.length > 0) {
                this.notification_list.forEach((notify) => {
                  let city = this.cityList.find(item => item.id == notify.city_id);

                  if (city) {
                    notify.city_name = city.name;
                  }
                });
              }

              this.total_items = response.data.notifications.total;
            }
          })
          .catch((error) => {
            console.log(error);
            // this.snack_bar.message = "Error Occured";
            // this.snack_bar.show;
          })
          .finally(() => {
            {
              this.loaders.notification_list_loader = false;
            }
          });
      this.is_loading = false;
    },
    getTitlesList: function (newVal) {
      this.loaders.notification_list_loader = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/notification-filter-title`,
              {headers: this.$headers, params: {searched_title: newVal}}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.title_list = response.data.titles;
            }
          })
          .catch((error) => {
            console.log(error);
            // this.snack_bar.message = "Error Occured";
            // this.snack_bar.show;
          })
          .finally(() => {
            {
              this.loaders.notification_list_loader = false;
            }
          });
      this.is_loading = false;
    },
    getCityList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name': "ALL" })
            }
          });
    }
  },
  mounted() {
    // console.log(this.$store.getters.get_user);
    this.getCityList();
    if (this.$route.params.message) {
      this.snackbar.display = true;
      this.snackbar.message = this.$route.params.message;
    }
  },
};
</script>

<style>
.add_notification {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);
}
</style>

